import React, { useEffect, useState } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Skeleton,
} from '@chakra-ui/react'
import { useDispatch, useSelector } from 'react-redux'
import { userUpdate } from '../../../../commons/redux/actions/user.actions'
export default function My() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { user } = useSelector((state) => state.userReducer)
  const [my, setMy] = useState()
  const [email, setEmail] = useState()
  const [tel, setTel] = useState()
  const [name, setName] = useState()

  const dispatch = useDispatch()
  const update = () => {
    try {
      dispatch(userUpdate({ name, tel, email }))
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (typeof window !== 'undefined' && user && Object.keys(user).length > 0) {
      setMy(user)
    }
  }, [user])

  return (
    <div className="my-3">
      <div className="text-2xl font-bold text-muted opacity-50">
        <h2>Mon Profil</h2>
      </div>
      {!my ? (
        <Skeleton height="200px" />
      ) : (
        <div className="bg-white rounded boder shadw-sm p-3 flex-col">
          <div className="flex justify-center items-center  flex-wrap">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/Breezeicons-actions-22-im-user.svg/1200px-Breezeicons-actions-22-im-user.svg.png"
              className="w-24 h-24 rounded-full border p-2"
              alt="logo"
            />

            <div className='leading-none'>

            <div className="">
            <p className="text-mute font-bold lead text-sm  ml-3">{my?.name}</p>
          </div>
          <div className="">
            <p className="text-muted text-sm ml-3">{my?.tel}</p>
          </div>
          <div className="">
            <p className="text-muted text-sm ml-3">{my?.email}</p>
          </div>
            </div>
            <button
              onClick={onOpen}
              className="font-bold text-muted ml-auto text-xs bg-gray-100 py-2 px-2"
            >
              modifier
            </button>
          </div>{' '}
        </div>
      )}

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Modifier un profil</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form class="w-full max-w-sm">
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label
                    class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    for="inline-full-name"
                  >
                    Nom{' '}
                  </label>
                </div>
                <div class="md:w-2/3">
                  <input
                    class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="inline-full-name"
                    type="text"
                    onChange={(e) => setName(e.target.value)}
                    defaultValue={my?.name}
                  />
                </div>
              </div>
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label
                    class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    for="inline-full-name"
                  >
                    Telephone{' '}
                  </label>
                </div>
                <div class="md:w-2/3">
                  <input
                    class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="inline-full-name"
                    type="text"
                    onChange={(e) => setTel(e.target.value)}
                    defaultValue={my?.tel}
                  />
                </div>
              </div>

              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label
                    class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    for="inline-full-name"
                  >
                    Email{' '}
                  </label>
                </div>
                <div class="md:w-2/3">
                  <input
                    class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="inline-full-name"
                    type="text"
                    onChange={(e) => setEmail(e.target.value)}
                    defaultValue={my?.email}
                  />
                </div>
              </div>
              <div class="md:flex md:items-center">
                <div class="md:w-1/3"></div>
                <div class="md:w-2/3">
                  <button
                    onClick={update}
                    class=" btn bg-gray-300 hover:bg-green-400 focus:shadow-outline focus:outline-none font-bold py-2 px-4 rounded"
                    type="button"
                  >
                    modifier{' '}
                  </button>
                </div>
              </div>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  )
}
